import React, { useEffect, useRef, useState } from "react";
import ThemeCardTable from "../../components/ThemeCardTable";
import { useQuery } from "@tanstack/react-query";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import ThemeCard from "../../components/ThemeCard";
import { Col, Pagination, Row, Tooltip, notification } from "antd";
import UserFilterComponant from "../../components/UserFilterComponant/UserFilterComponant";
import { useDispatch, useSelector } from "react-redux";
import { setUserClearFilter } from "../../store/slice/globleSlice";
import { formatToINR } from "../../components/FormateToINR/formatToINR";
import GetDate from "../../components/DatePicker/GetDate";
import useGetQueryParams from "../../hooks/useGetQueryParams";
import { valanBillDate } from "../../components/CommanFuction/CommanFunction";
import { PaginationRow, StyledButton } from "../../styles/commonStyle";
import { labelObj } from "../../Helper/constant";
import { UplineTag } from "../Users/Accounts/style";

const M2mAlertLog = () => {
  const valueRef = useRef({});
  const dispatch = useDispatch();
  const { params, setSearchParams } = useGetQueryParams();
  // state
  const [pages, setPage] = useState({ page: 1 });

  //redux
  const loginUserId = useSelector(
    (state) => state.authSlice?.userDetail?.userId
  );
  const filterUser = useSelector((state) => state?.globleSlice?.filterUsers);

  //life cycle
  useEffect(() => {
    setSearchParams({
      ...params,
      userId: params?.userId ? params.userId : loginUserId,
    });
  }, []);

  useEffect(() => {
    if (Object.keys(params)?.length === 0) {
      setSearchParams({ userId: loginUserId });
    }
  }, [params]);

  // api call
  const getM2mAlert = async () => {
    let isAllow = filterUser?.includes(Number(params?.userId));
    if (!isAllow) {
      notification.error({ message: "User Id is not valid" });
      return [];
    }
    const obj = {
      userId: Number(params?.userId) || null,
      startDate: params?.startDate || null,
      endDate: params?.endDate || null,
    };
    let response = await APICall(
      "post",
      `${EndPoints.getM2MAlert}&page=${params?.page || 1}&limit=${
        params?.limit || 10
      }`,
      obj
    );

    const data = response?.data?.data;
    setPage({
      page: data?.currentPage,
      nextPage: data?.nextPage,
      totalCount: data?.totalCount,
      totalPages: data?.totalPages,
    });
    return response?.data?.data;
  };

  const {
    isLoading,
    error: M2mAlertError,
    data: M2mAlert,
  } = useQuery({
    queryKey: ["m2mAlert", params],
    queryFn: getM2mAlert,
    enabled: Object.keys(params)?.length > 0,
  });

  if (M2mAlertError) notification.error({ message: M2mAlertError?.message });

  // function
  const handleSearch = () => {
    let payloadValue = valueRef.current;
    let valueObj = {
      userId: payloadValue?.userId || loginUserId,
      startDate: payloadValue?.startDate?.toISOString() || null,
      endDate: payloadValue?.endDate?.toISOString() || null,
      page: 1,
    };

    for (let key in valueObj) {
      if (!valueObj[key]) {
        delete valueObj[key];
      }
    }
    setSearchParams(valueObj);
  };

  const handleClear = () => {
    dispatch(setUserClearFilter(true));
    valueRef.current = {};

    setSearchParams({ userId: loginUserId });
  };

  const handlePageChange = (value) => {
    setSearchParams({ ...params, page: value });
  };

  // column
  const m2mAlertColumns = [
    isLoading
      ? { title: "TIME", dataIndex: "time", key: "time" }
      : {
          title: "TIME",
          dataIndex: "time",
          key: "time",
          flex: 1,
          align: "center",
          render: (text, record) => {
            const time = valanBillDate(record?.alertTime, true);
            return <span>{time}</span>;
          },
        },
        {
          title: "CLIENT",
          dataIndex: "client",
          key: "client",
          align: "left",
          flex: 1,
          ellipsis: true,
          render: (text, record) => {
            return (
              <Tooltip
                title={`${record?.customerId?.userId} (${record?.customerId?.accountName})`}
                placement="top"
              >
                <div>
                  <div style={{ fontWeight: "bold" }}>{record?.customerId?.userId}</div>
                  <div >{record?.customerId?.accountName}</div>
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: "UPLINE",
          dataIndex: "upline",
          key: "upline",
          align: "left",
          flex: 1,
          ellipsis: true,
          render: (text, record) => {
            let id = record?.customerId?.parent?.userId;
            return (
              <Tooltip
                title={`${id} (${record?.customerId?.parent?.accountName})`}
                placement="top"
              >
                <div>
                  <div style={{ fontWeight: "bold" }}>{id}<UplineTag color="magenta" bordered={false}>
                        {labelObj[record?.customerId?.parent?.accountType]}
                      </UplineTag></div>
                  <div >{record?.customerId?.parent?.accountName}</div>
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: "TYPE",
          dataIndex: "type",
          key: "type",
          align: "left",
          flex: 1,
          render: (text, record) => {
            return !isLoading && <div>{record?.type?.toUpperCase()}</div>;
          },
        },
    {
      title: "MESSAGE",
      dataIndex: "script",
      key: "script",
      align: "left",
      flex: 1,
      render: (text, record) => {
        return !isLoading && <div>{record?.data?.message}</div>;
      },
    },
    {
      title: "M2M",
      dataIndex: "type",
      key: "type",
      align: "center",
      flex: 1,
      render: (text, record) => {
        return !isLoading && <span>{formatToINR(record?.data?.amount)}</span>;
      },
    },
    {
      title: "LEDGER + M2M",
      dataIndex: "lot",
      key: "lot",
      align: "center",
      flex: 1,
      render: (text, record) => {
        return !isLoading && <span>{formatToINR(record?.data?.balance)}</span>;
      },
    },
  ];

  return (
    <>
      <ThemeCard
      // title="M2mAlert Log"
      >
        <Row gutter={[10, 15]}>
          <GetDate valueRef={valueRef} />
          <UserFilterComponant valueRef={valueRef} />
        </Row>
        <Row gutter={[10, 15]} style={{ marginTop: "2rem" }}>
          <Col xs={24} sm={12} md={4} lg={3} xl={2}>
            <StyledButton type="primary" onClick={handleSearch}>
              Search
            </StyledButton>
          </Col>
          <Col xs={24} sm={12} md={4} lg={3} xl={2}>
            <StyledButton type="primary" onClick={handleClear}>
              Clear Search
            </StyledButton>
          </Col>
        </Row>
      </ThemeCard>
      <ThemeCardTable
        buttonType={false}
        data={M2mAlert ? M2mAlert?.alerts : []}
        column={m2mAlertColumns}
        isLoading={isLoading}
        headingStyle={false}
        isFilterTrue={true}
        filtertype="m2m"
      />
      <PaginationRow>
        <Pagination
          currentPage={params?.page || 1}
          total={pages?.totalCount}
          pageSize={params?.limit || 10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </PaginationRow>
    </>
  );
};

export default M2mAlertLog;
